import React, { useCallback, useMemo, useState } from 'react';
import GameCard from '../gameCard';
import ButtonFulfilled from '../../uiKit/buttons/fulfilled';
import { useTranslation } from 'react-i18next';
import { getGamesList, useGetGamesDataQuery } from '../../redux/api/games';
import { useSelector } from 'react-redux';
import { useImagePreload } from '../../utils/hooks/useImagePreload';
import GameCardSkeleton from '../gameCard/skeleton';
import GameOfMonthBlock from '../gameOfMonthBlock';
import Title from '../../uiKit/typography/title';

export default React.memo(function GamesList({ searchParams, gamesListNodeId }) {
  const { t } = useTranslation('common');
  const { isFetching } = useGetGamesDataQuery();
  const gamesList = useSelector(getGamesList);
  const loaded = useImagePreload(gamesList.reduce((res, game) => {
    res.push(game.iconPreview, game.iconSquare);
    return res;
  }, []));

  const [page, setPage] = useState(1);
  const [openCardId, setOpenCardId] = useState(null);
  const gamesOnPage = 16;

  const gamesLimit = gamesOnPage * page;

  const filteredGames = useMemo(() => {
    return gamesList.filter(item => {
      let match = true;

      if (searchParams.hasOwnProperty('term')) {
        if (!item.name.toUpperCase().includes(searchParams.term.toUpperCase()) &&
          !item.gameBundle.toUpperCase().includes(searchParams.term.toUpperCase())) match = false;
      }

      if (searchParams.hasOwnProperty('type')) {
        if (searchParams.type.some(id => !item.gameTypeIds.includes(id))) match = false;
      }

      // if (searchParams.hasOwnProperty('feature')) {
      //   if (searchParams.feature.some(id => !item.gameFeatureIds.includes(id))) match = false;
      // }

      return match;
    });
  }, [searchParams, gamesList]);

  const list = useMemo(() => {
    return filteredGames.length ? filteredGames : (gamesList.length ? [] : Array.from({ length: page * gamesOnPage }, () => null));
  }, [filteredGames, gamesList, page, gamesOnPage]);

  const onCardClick = useCallback((id) => {
    setOpenCardId(id);
  }, []);

  const showMore = () => {
    setPage(prev => prev + 1);
  };

  const showLoadMoreButton = gamesLimit < filteredGames.length;

  return (
    <div className={'w-full flex flex-col gap-8'}>

      <GameOfMonthBlock />

      <div className={'flex flex-col gap-8 pt-20'} id={gamesListNodeId}>
        <Title>
          {t('titles.our_games')}
        </Title>

        <div className={'flex flex-col items-center gap-24'}>
          <div
            className={`grid grid-cols-[repeat(auto-fit,minmax(0,16.25rem))] auto-rows-[16.25rem] max-w-[calc(theme(space.6)*3+16.25rem*4)] place-content-center justify-center gap-6 w-full [&>*]:w-[16.25rem]`}>
            {list.slice(0, page * gamesOnPage).map((game, index) => game && loaded.includes(game.iconSquare) && loaded.includes(game.iconPreview) ?
              <GameCard key={game.gameBundle} game={game} callback={onCardClick} isOpen={game.id === openCardId} /> :
              <GameCardSkeleton key={index} />
            )}
          </div>

          {showLoadMoreButton && <div className={'w-full flex items-center justify-center'}>
            <ButtonFulfilled className={'w-[18.125rem] py-2.5'} onClick={showMore}>
              {t('buttons.load_more')}
            </ButtonFulfilled>
          </div>}
        </div>
      </div>
    </div>
  );
});
